import { parseTaskResponseToTaskVm } from '../../api/typeConverters'
import { Task } from '../../types/commonTypes'
import { t } from 'i18next'
import { LearningGoal } from './EngineHelper'

const baseMatchPairs = {
  name: 'Moikkismoi',
  x: 50,
  y: 50,
  map_id: -1,
  type: 'CombineExercise',
  description: '<p>Kysymysteksti&auml; ompi t&auml;ss&auml;</p>',
  game_id: 4905,
  temp_id: 469325,
  points: 2,
  is_flash: false,
  icon_type: 'seppo',
  open: true,
  level: 1,
}
const baseMultichoice = {
  name: 'NIMI',
  x: 50,
  y: 50,
  map_id: -1,
  type: 'MultichoiceExercise',
  description: '<p>KYSYMYS</p>',
  game_id: 4905,
  temp_id: 423191,
  data: {
    choices: ['Eka vastaus', 'Toka vastaus', 'Kolmas vastaus'],
    points: [1, 0, 0],
    picture_urls: [''],
    next_ex_ids: ['0'],
    feedbacks: [''],
    correct_index: 0,
    correct: 'Eka vastaus',
  },
  points: 1,
  is_flash: false,
  icon_type: 'seppo',
  open: true,
  level: 1,
}
const baseCheckbox = {
  name: 'Checkbox',
  x: 50,
  y: 50,
  map_id: -1,
  type: 'PollExercise',
  description: '<p>QUESTION</p>',
  game_id: 4905,
  temp_id: 682530,
  data: {
    choices: ['OPTION1', 'OPTION2', 'OPTION3'],
    points: [5, 5, 2],
    picture_urls: ['', '', ''],
    next_ex_ids: [null, null, null],
    feedbacks: ['', '', ''],
    correct_index: '',
    correct: '',
    feedback: '',
  },
  points: 12,
  is_flash: false,
  icon_type: 'seppo',
  open: true,
  level: 1,
}
const baseMissingWord = {
  name: 'MissingWord',
  x: 50,
  y: 50,
  map_id: -1,
  type: 'MissingWordExercise',
  description: '<p>Guess what is missing from SLOT1 and here SLOT2</p>',
  game_id: 4905,
  temp_id: 463441,
  data: {
    choices: ['OPTION1', 'OPTION2', 'OPTION3'],
    points: [5, 5, 2],
  },
  points: 10,
  is_flash: false,
  icon_type: 'seppo',
  open: true,
  level: 1,
}
const baseCreative = {
  name: 'Upgradable Golden brush-tailed possum',
  x: 50,
  y: 50,
  map_id: -1,
  type: 'CreativeExercise',
  description: '<p>Scott Mountain Phacelia</p>',
  game_id: 4905,
  temp_id: 679759,
  points: 1000,
  allows_text: true,
  allows_image: true,
  allows_video: true,
  allows_audio: true,
  default_feedback: null,
  reference_answer: null,
  icon_type: 'seppo',
  open: true,
  level: 1,
}
const missingWordSlot =
  '<input id="field_INDEX" class="form-control added_field_in_tinymice_editor" style="margin: 0 4px;" disabled="disabled" type="textarea" placeholder="Word-INDEX">'

const convertToCreative = (gameId: number, rawJson: any) => {
  let data = JSON.parse(JSON.stringify(baseCreative))
  data.game_id = gameId
  data.name = rawJson.name
  data.description = '<p>' + rawJson.question + '</p>'
  data.allows_image = rawJson.allowImage
  data.allows_video = rawJson.allowVideo
  data.allows_audio = rawJson.allowAudio
  return data
}

const convertToMatchPairs = (gameId: number, rawJson: any) => {
  let data = JSON.parse(JSON.stringify(baseMatchPairs))
  data.game_id = gameId
  data.name = rawJson.name
  data.description = '<p>' + rawJson.question + '</p>'
  data.data = {}
  data.data.choices = (
    rawJson.choiceOptions ||
    rawJson.options ||
    rawJson.choices ||
    rawJson.pairs ||
    rawJson.task
  ).map((pair: any) => {
    return { leftText: pair.left, rightText: pair.right }
  })
  data.data.points = (rawJson.choiceOptions || rawJson.options || rawJson.choices || rawJson.pairs || rawJson.task).map(
    (pair: any) => {
      return 1000
    },
  )
  data.points =
    (rawJson.choiceOptions || rawJson.options || rawJson.choices || rawJson.pairs || rawJson.task).length * 1000
  return data
}

const convertToMissingWord = (gameId: number, rawJson: any) => {
  let data = JSON.parse(JSON.stringify(baseMissingWord))
  if ((rawJson.question.match(/SLOT1/g) || []).length !== 1) return -2
  data.game_id = gameId
  data.name = rawJson.name
  const type = rawJson.taskType || rawJson.type
  if (type.includes('ORDER')) {
    data.description = rawJson.question.replaceAll('SLOT', '<br/> SLOT')
  } else {
    data.description = rawJson.question
  }
  data.description =
    '<p>' +
    data.description
      .replace('SLOT1', missingWordSlot.replaceAll('INDEX', '1'))
      .replaceAll('SLOT2', missingWordSlot.replaceAll('INDEX', '2'))
      .replaceAll('SLOT3', missingWordSlot.replaceAll('INDEX', '3'))
      .replaceAll('SLOT4', missingWordSlot.replaceAll('INDEX', '4'))
      .replace('SLOT5', missingWordSlot.replaceAll('INDEX', '5'))
      .replaceAll('SLOT6', missingWordSlot.replaceAll('INDEX', '6'))
      .replaceAll('SLOT7', missingWordSlot.replaceAll('INDEX', '7'))
      .replaceAll('SLOT8', missingWordSlot.replaceAll('INDEX', '8')) +
    '</p>'

  data.data = {}
  data.data.choices = rawJson.options || rawJson.choiceOptions || rawJson.choices
  if (!data.data.choices || typeof data.data.choices[0] !== 'string') return -2
  if (rawJson.hintWords) {
    const extendedHintWords = rawJson.hintWords.join(',').toLowerCase().split(',')
    data.data.choices.forEach((choiseString: string) => {
      const firstCorrectWord = choiseString.split(';')[0]
      if (!extendedHintWords.includes(firstCorrectWord.toLowerCase()))
        extendedHintWords.push(firstCorrectWord.toLowerCase())
    })
    data.description +=
      '<br/>' + t('engine.missing_word_hints', 'Hints: %{hints}', { hints: extendedHintWords.join(', ') })
  }
  data.data.points = (rawJson.options || rawJson.choiceOptions || rawJson.choices).map(() => {
    return 1000
  })
  return data
}

const convertToMultichoice = (gameId: number, rawJson: any) => {
  let data = JSON.parse(JSON.stringify(baseMultichoice))
  data.game_id = gameId
  data.name = rawJson.name
  data.description = '<p>' + rawJson.question + '</p>'
  data.data.choices = rawJson.options || rawJson.choiceOptions || rawJson.choices
  // console.log('multichoice')
  // console.log(data.data)
  // console.log(typeof data.data.choices[0])
  if (typeof data.data.choices[0] !== 'string' || rawJson.points === undefined) return -1
  //Sometimes with the intro task the choices data is like: [{"text"=>"Let's go", "isCorrect"=>true}]
  try {
    if (typeof data.data.choices[0] == 'object' && data.data.choices.length === 1) {
      data.data.choices = [Object.values(data.data.choices[0])[0]]
    }
  } catch (e) {}
  data.data.correct_index = rawJson.correctOptionIndex
  data.data.points = (rawJson.options || rawJson.choiceOptions || rawJson.choices).map((opt: any, index: number) =>
    index === parseInt(rawJson.correctOptionIndex) ? 1000 : 0,
  )
  data.points = 1000
  return data
}

const convertToCheckbox = (gameId: number, rawJson: any) => {
  let data = JSON.parse(JSON.stringify(baseCheckbox))
  data.game_id = gameId
  data.name = rawJson.name
  data.description = '<p>' + rawJson.question + '</p>'
  data.data.choices = rawJson.options || rawJson.choiceOptions || rawJson.choices
  data.data.points = rawJson.points.map((p: number) => p * 100)
  // console.log('checkbox')
  // console.log(data.data)
  // console.log(typeof data.data.choices[0])
  if (typeof data.data.choices[0] !== 'string' || rawJson.points === undefined) return -1
  try {
    data.points = data.data.points.reduce((partialSum: number, a: number) => partialSum + Math.max(a, 0), 0)
  } catch (e) {}
  return data
}

export const getTaskFromJson = (gameId: number, oneTaskJson: any, is3D: boolean): Task | string | null => {
  let exercisesString
  const type = oneTaskJson.taskType || oneTaskJson.type
  try {
    if (type.includes('MATCH')) exercisesString = convertToMatchPairs(gameId, oneTaskJson)
    else if (type.includes('MULTI')) exercisesString = convertToMultichoice(gameId, oneTaskJson)
    else if (type.includes('CHECK')) exercisesString = convertToCheckbox(gameId, oneTaskJson)
    else if (type.includes('MISSING')) exercisesString = convertToMissingWord(gameId, oneTaskJson)
    else if (type.includes('ORDER')) exercisesString = convertToMissingWord(gameId, oneTaskJson)
    else if (type === 'CREATIVE') exercisesString = convertToCreative(gameId, oneTaskJson)
  } catch (e) {
    return oneTaskJson.slotId
  }

  if (typeof exercisesString === 'number' || exercisesString === null) return oneTaskJson.slotId

  exercisesString.x = 20 + Math.floor(oneTaskJson.order_number % 8) * 5
  exercisesString.y = 35 + Math.floor(oneTaskJson.order_number / 8) * 10
  exercisesString.order_number = oneTaskJson.order_number
  if (oneTaskJson.order_number === 0 && !is3D) {
    exercisesString.level = 0
  }
  exercisesString.children = []

  return parseTaskResponseToTaskVm(exercisesString)
}

export const getNextJsonSnippet = (startIndex: number, text: string): { nextStartIndex: number; jsonObject: any } => {
  // console.log(startIndex)
  // console.log(text.substring(startIndex, startIndex + 100))
  const jsonStart = startIndex + findJsonStartIndex(text.substring(startIndex)) //text.indexOf('slotId', startIndex)
  //console.log(jsonStart)
  if (jsonStart < startIndex) return { nextStartIndex: -1, jsonObject: null }
  const jsonEnd = jsonStart + findJsonEndIndex(text.substring(jsonStart)) //text.indexOf('```', jsonStart)
  const origJsonText = text.substring(jsonStart, jsonEnd)
  let jsonText = origJsonText.replaceAll('<br/>', '').replaceAll('<br />', '').replaceAll('---', '').trim()
  //Sometimes the json might end with double } or it might be missing or a single task has been placed into an array
  if (jsonText[jsonText.length - 1] === ']') jsonText = jsonText.substring(0, jsonText.length - 1)
  if (jsonText[jsonText.length - 1] !== '}') jsonText += '}'
  jsonText = jsonText.replace('}}', '}')
  jsonText = jsonText.replace('```', '')

  console.log(text.substring(jsonStart, jsonStart + 501))
  console.log(jsonText)
  let jsonObject
  try {
    jsonObject = JSONSafeParse(jsonText)
    jsonObject.order_number = jsonObject.slotId
  } catch (e) {
    console.log(e)
    jsonObject = null
  }
  const thereIsMore = findJsonStartIndex(text.substring(jsonEnd)) > -1
  return { nextStartIndex: thereIsMore ? jsonEnd : -1, jsonObject }
}

// export const getLearningGoals = (startIndex: number, text: string): { nextStartIndex: number; jsonObject: any } => {
//   const jsonStart = startIndex + findJsonArrayStartIndex(text.substring(startIndex)) //text.indexOf('slotId', startIndex)
//   if (jsonStart < startIndex) return { nextStartIndex: -1, jsonObject: null }
//   let jsonEnd = text.indexOf('```', jsonStart)
//   const origJsonText = jsonEnd > -1 ? text.substring(jsonStart, jsonEnd) : text.substring(jsonStart)
//   let jsonText = origJsonText.replaceAll('<br/>', '').replaceAll('<br />', '').replaceAll('---','').replaceAll('json','').trim()
//   //console.log(jsonText)
//   //Sometimes the json might end with double } or it might be missing or a single task has been placed into an array
//   jsonText=jsonText.replace('}}','}')
//   jsonText=jsonText.replace('```','')

//   let jsonObject
//   try {
//     jsonObject = JSONSafeParse(jsonText)
//   } catch (e) {
//     console.log(e)
//     jsonObject = null
//   }
//   const thereIsMore = findJsonStartIndex(text.substring(jsonEnd)) > -1
//   return { nextStartIndex: thereIsMore ? jsonEnd : -1, jsonObject }
// }

export const getLearningGoals = (startIndex: number, text: string): { jsonObject: any } => {
  const results: LearningGoal[] = []

  // Match JSON objects at top level (non-greedy)
  const objectRegex = /\{[\s\S]*?\}/g
  const matches = text.match(objectRegex)

  if (!matches) {
    return {jsonObject: results}
  }

  for (const match of matches) {
    try {
      const parsed = JSON.parse(match)
      console.log(parsed)

      // Basic shape validation
      if (typeof parsed.id === 'number' && typeof parsed.title === 'string' && typeof parsed.text === 'string') {
        results.push(parsed)
      }
    } catch {
      // Ignore malformed objects
    }
  }

  return { jsonObject: results }
}

export const findJsonStartIndex = (input: string): number => {
  // Find the position of the `"slotId"` string first
  let slotIdx = input.indexOf('"slotId"')
  if (slotIdx === -1) slotIdx = input.indexOf('slotId:')
  if (slotIdx === -1) return -1 // no JSON with slotId found

  // Walk backward to find the nearest `{` before that index
  for (let i = slotIdx; i >= 0; i--) {
    if (input[i] === '{') return i
  }

  return -1 // not found
}

const MAX_INDEX = 100000
export const findJsonEndIndex = (input: string): number => {
  let bracketCount = 1
  let index = 1
  while (bracketCount > 0 && index < MAX_INDEX) {
    if (input[index] === '{') bracketCount++
    if (input[index] === '}') bracketCount--
    index++
  }

  return index
}

export const findJsonArrayStartIndex = (input: string): number => {
  // Find the position of the `"slotId"` string first
  let slotIdx = input.indexOf('"title"')
  if (slotIdx === -1) slotIdx = input.indexOf('title:')
  if (slotIdx === -1) return -1 // no JSON with slotId found

  // Walk backward to find the nearest `{` before that index
  for (let i = slotIdx; i >= 0; i--) {
    if (input[i] === '[') return i
  }

  return -1 // not found
}

export const JSONSafeParse = (input: string) => {
  // If it's already valid JSON, return as-is
  try {
    return JSON.parse(input)
  } catch {}

  // Add double quotes around unquoted keys
  let fixed = input
    // Add quotes to keys like slotId: → "slotId":
    .replace(/([{,]\s*)([A-Za-z0-9_]+)\s*:/g, '$1"$2":')
  //For some strange reason it often doesn't end the last json object with }
  const lastQuoteMarkIndex = input.lastIndexOf('"')
  if (input[lastQuoteMarkIndex + 1] !== '}') {
    fixed = fixed.substring(0, lastQuoteMarkIndex + 1) + '}' + fixed.substring(lastQuoteMarkIndex + 1)
  }
  // Try to parse again after fixing
  try {
    return JSON.parse(fixed)
  } catch (err: any) {
    console.error('Invalid JSON after attempting to fix:', err)
    console.log(fixed)
    throw new Error('Could not fix JSON: ' + err.message)
  }
}
